//app start point
/*document.domain = 'backoffice.com';*/
angular.module("app", [
    // 3rd party modules
    'restangular',
    'ui.router',
    'ui.bootstrap',
    'ngCookies',
    'pascalprecht.translate',
    'ncy-angular-breadcrumb',
    'toastr',
    'ngFileUpload',
    'ngCropper',
    'jcs-autoValidate',
    'colorpicker.module',
    'angularjs-dropdown-multiselect',
    'uiSwitch',
    'gridster',
    'directive.loading',
    'as.sortable',
    'localytics.directives',
    //custom modules
    'app.modalControllers',
    'ng.navigation',
    'ngTable',
    'ngTagsInput',
    'fancyboxplus',
    'ui.codemirror',
    'ngFileSaver'
]).run([
    '$rootScope',
    '$state',
    'userStorage',
    'validator',
    'validationElementModifier',
    'settingsService',
    'stateAliases',
    'userService',
    function ($rootScope, $state, UserStorage, validator, validationElementModifier, settingsService, stateAliases, userService) {

        var settings = settingsService.getSettings(),
            getPreferredState = settingsService.getPreferredState(),
            siteMap,
            allowedStates;

        validator.registerDomModifier(validationElementModifier.key, validationElementModifier);
        validator.setDefaultElementModifier(validationElementModifier.key);

        $rootScope.$on('$stateChangeStart', function ($event, to) {
            settings = settingsService.getSettings();
            allowedStates = settingsService.getAllowedStates() || [];
            siteMap = stateAliases.getSiteMapArray() || [];
            if (UserStorage.isAuthenticated()) {
                if ((!~siteMap.indexOf(to.name) || !allowedStates.length) && to.name !== "login") {
                    $event.preventDefault();
                 /* userService.logout();
                    UserStorage.resetUserData();
                    settingsService.reset();*/
                    alert("Sorry. Contact your skin provider to add for you necessary configurations. Your account haven't any visible states");
                   // return $state.go('login')
                }

                if (to.name == "login") {
                    $event.preventDefault();
                    $state.go(getPreferredState("main.configs.general"));
                    return
                }

/*                if (!settings.allowGlobalActions && to.name == "main.pages.add") {
                    $event.preventDefault();
                    $state.go(getPreferredState("main.configs"));
                }*/

                if (getPreferredState(to.name) != to.name) {
                    $event.preventDefault();
                    $state.go(getPreferredState(to.name));
                }

            } else if (to.name != "login"){
                $event.preventDefault();
              //  $state.go("login", null, {reload: true})
            }
        });
        $rootScope.broadcast = function (event, data) {
            $rootScope.$broadcast(event, data);
        };
    }
]).value("taCustomRenderers", [
    {
        selector: "iframe",
        customAttribute: "ta-insert-img",
        renderLogic: function (element) {
            var img = angular.element("<img />"), attributes = element.prop("attributes");
            angular.forEach(attributes, function (element) {
                img.attr(element.name, element.value)
            });
            img.attr("ta-insert-video", img.attr("src"));
            img.attr("src", img.attr("ta-insert-img"));
            element.replaceWith(img)
        }
    },
    {
        selector: "img",
        customAttribute: "ta-insert-video",
        renderLogic: function (element) {
            var iframe = angular.element("<iframe></iframe>"), attributes = element.prop("attributes");
            angular.forEach(attributes, function (element) {
                iframe.attr(element.name, element.value)
            });
            iframe.attr("ta-insert-img", iframe.attr("src"));
            iframe.attr("src", iframe.attr("ta-insert-video"));

            element.replaceWith(iframe)
        }
    }
])
